import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/components/login.component';
import { canCreateUserGuard, hasOperativeRoleGuard, isAdminGuard, isAuthorizedGuard, isInternSuperUserGuard } from './auth/guards/is-authorized.guard';
import { AntibioticCalcComponent } from './pages/analys-resultat/antibiotic-calc/antibiotic-calc.component';
import { GeneralSearchComponent } from './pages/analys-resultat/general-search/general-search.component';
import { NamnardataSearchComponent } from './pages/analys-resultat/namnardata-search/namnardata-search.component';
import { SearchResultListComponent } from './pages/analys-resultat/specific-search-result-list/search-result-list.component';
import { SpecificSpeciesSearchComponent } from './pages/analys-resultat/specific-species-search/specific-species-search.component';
import { AnvandareComponent } from './pages/anvandare/anvandare.component';
import { EditAnvandareComponent } from './pages/anvandare/edit-anvandare/edit-anvandare.component';
import { AtgardsListaComponent } from './pages/atgards-lista/atgards-lista.component';
import { IgnoreradeComponent } from './pages/ignorerade/ignorerade.component';
import { InskicksResultatComponent } from './pages/inskicks-resultat/inskicks-resultat.component';
import { LaggaTillAnvandareComponent } from './pages/lagga-till-anvandare/lagga-till-anvandare.component';
import { LarmHistorikComponent } from './pages/larm-historik/larm-historik.component';
import { LarmKriteriumComponent } from './pages/larm-kriterium/larm-kriterium.component';
import { NyttLarmKriteriumComponent } from './pages/larm-kriterium/nytt-larm-kriterium/nytt-larm-kriterium.component';
import { LarmComponent } from './pages/larm/larm.component';
import { StandardNamnComponent } from './pages/standard-namn/standard-namn.component';
import { StartsidaComponent } from './pages/startsida/startsida.component';
import { SynonymerComponent } from './pages/synonymer/synonymer.component';
import { ValjOrganisationComponent } from './auth/components/valj-organisation/valj-organisation.component';
import { StandardNameUpdateGuard } from './pages/startsida/StandardNameUpdateGuard';

const routes: Routes = [
  {
    path: 'logga-in',
    component: LoginComponent,
    data: { loggedInRoute: 'startsida', multipleOrganisations: 'valj-organisation' },
  },
  {
    path: 'startsida',
    component: StartsidaComponent,
    canActivate: [isAuthorizedGuard],
  },
  {
    path: 'valj-organisation',
    component: ValjOrganisationComponent,
    canActivate: [isAuthorizedGuard],
  },
  {
    path: 'atgardslista',
    component: AtgardsListaComponent,
    canActivate: [isAuthorizedGuard],
  },
  {
    path: 'larm-nya',
    component: LarmComponent,
    canActivate: [isAuthorizedGuard, hasOperativeRoleGuard],
  },
  {
    path: 'larm-kriterium',
    component: LarmKriteriumComponent,
    canActivate: [isAuthorizedGuard, hasOperativeRoleGuard],
  },
  {
    path: 'nytt-larm-kriterium',
    component: NyttLarmKriteriumComponent,
    canActivate: [isAuthorizedGuard, hasOperativeRoleGuard],
  },
  {
    path: 'larm-historik',
    component: LarmHistorikComponent,
    canActivate: [isAuthorizedGuard],
  },
  {
    path: 'inskicksresultat',
    component: InskicksResultatComponent,
    canActivate: [isAuthorizedGuard, isInternSuperUserGuard],
  },
  {
    path: 'analysresultat',
    component: SpecificSpeciesSearchComponent,
    canActivate: [isAuthorizedGuard, StandardNameUpdateGuard],
  },
  {
    path: 'generalSearch',
    component: GeneralSearchComponent,
    canActivate: [isAuthorizedGuard, StandardNameUpdateGuard],
  },
  {
    path: 'namnardata-search',
    component: NamnardataSearchComponent,
    canActivate: [isAuthorizedGuard, StandardNameUpdateGuard],
  },
  {
    path: 'antibiotic-calc',
    component: AntibioticCalcComponent,
    canActivate: [isAuthorizedGuard],
  },
  {
    path: 'search-results',
    component: SearchResultListComponent,
    canActivate: [isAuthorizedGuard],
  },
  {
    path: 'standardnamn',
    component: StandardNamnComponent,
    canActivate: [isAuthorizedGuard],
  },
  {
    path: 'synonymer',
    component: SynonymerComponent,
    canActivate: [isAuthorizedGuard],
  },
  {
    path: 'ignorerade',
    component: IgnoreradeComponent,
    canActivate: [isAuthorizedGuard],
  },
  {
    path: 'anvandare',
    component: AnvandareComponent,
    canActivate: [isAuthorizedGuard, isAdminGuard],
  },
  {
    path: 'anvandare/:id',
    component: EditAnvandareComponent,
    canActivate: [isAuthorizedGuard, isAdminGuard],
  },
  {
    path: 'lagg-till-anvandare',
    component: LaggaTillAnvandareComponent,
    canActivate: [isAuthorizedGuard, canCreateUserGuard],
  },
  {
    path: '',
    redirectTo: 'logga-in',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'logga-in',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
